import { CurrentUser } from './models/current-user.model';

export class AppStorage {
  currentUser: CurrentUser = null;

  constructor() {
    this.initStorage();
  }

  initStorage() {
    const localUser = localStorage.getItem('currentUser');
    if (localUser) {
      this.currentUser = JSON.parse(localUser) as CurrentUser;
      // localStorage.setItem('communityId', `${this.currentUser.community_id}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.storage.ts